import { REMOVE_USER_ALERT, SHOW_USER_ALERT } from "./types";
import { v4 as uuid } from "uuid";

export const showUserAlert = (alert) => (dispatch) => {
  const newAlertId = uuid();
  dispatch({
    type: SHOW_USER_ALERT,
    payload: { ...alert, id: newAlertId },
  });
  setTimeout(() => {
    dispatch({
      type: REMOVE_USER_ALERT,
      payload: newAlertId,
    });
  }, 30 * 1000);
};

export const removeUserAlert = (alertId) => (dispatch) => {
  dispatch({
    type: REMOVE_USER_ALERT,
    payload: alertId,
  });
};
